import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { handleGetRequest } from '../../services/GetTemplate';

const getTblUserSlice = createSlice({
    name: "tblUser",
    initialState: {
        isLoading: false,
        data: [],
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(getTblUser.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getTblUser.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        })
        builder.addCase(getTblUser.rejected, (state, action) => {
            state.isError = true;
        })
    }
})

export const getTblUser = createAsyncThunk("getTblUser", async () => {
    const res = await handleGetRequest(`/configuration/v1/lookups/getusers/TBL_USER:*`);
    return res?.payLoad;
});

export default getTblUserSlice.reducer